module.exports = __webpack_public_path__ + "img/neolicitador_blanco.70d9d45d.png";